<template>
  <div class="side-page-lower-container">
    <div
      id="side-page-dyk"
      class="side-page-text"
    >
      <p id="side-page-dyk-header">
        {{ $t('portalfrontendApp.sidePage.didYouKnow.header') }}
      </p>
      <p id="side-page-dyk-tidbit">
        {{ $t('portalfrontendApp.sidePage.didYouKnow.tidbits') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DidYouKnowCta'
}
</script>

<style lang="scss">
  @import "~@/assets/scss/variables";
  @import "~@/assets/scss/mixins.scss";

  #side-page-container {
    .side-page-text {
      align-self: center;
      &#side-page-dyk {
        align-self: center;

        #side-page-dyk-header {
          @include gotham-medium;
          color: var(--t-color-text-inverted);
          font-size: var(--t-font-size-4);
          line-height: 36px;
        }

        #side-page-dyk-tidbit {
          color: var(--t-color-text-inverted);
          font-size: var(--t-font-size-2);          //18px/1.125rem
          line-height: var(--t-font-lineheight-3);  //24px/1.5rem
        }
      }
    }

    .side-page-text {
      color: var(--t-color-text-inverted);
      padding-inline: 5rem;

      p {
        margin-bottom: 0;
      }
    }
  }
  @media (max-width: $breakpoint-lg - 1) {
    #side-page {

      &.did-you-know-background {

        #side-page-container {

          .side-page-lower-container {

            .side-page-text {

              &#side-page-dyk {
                margin: 60px 30px 30px;
                width: 60%;
                display: none;

                #side-page-dyk-header {
                  font-size: 16px;
                  line-height: 18px;
                }

                #side-page-dyk-tidbit {
                  font-size: 14px;
                  line-height: 18px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
